import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DomHandlerService } from '@services/dom-handler.service';
import { Settings, SettingsService } from '@services/settings.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoaderComponent } from './admin/loader/loader.component';
import { globalEmitterService } from '@services/globalEmitter.service';

@Component({
  selector: 'app-root',
  imports: [
    NgClass,
    RouterOutlet,
    TranslateModule,
    NgxSpinnerModule,
    LoaderComponent,
    CommonModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  loading: boolean = true;
  public settings: Settings;
  isServer: boolean = true;

  constructor(
    public settingsService: SettingsService,
    public router: Router,
    public translate: TranslateService,
    public domHandlerService: DomHandlerService,
    private globalEmitterService: globalEmitterService,
    private cd: ChangeDetectorRef
  ) {
    this.settings = this.settingsService.settings;
    translate.addLangs(['en', 'de', 'fr', 'ru', 'tr']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
    if (this.domHandlerService.isBrowser) {
      setTimeout(() => {
        this.isServer = false;
      });
    }
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     setTimeout(() => (this.loading = false), 3000); // small delay for effect
    //   }
    // });
    this.globalEmitterService.loaderUpdate.subscribe((res) => {
      if (res) {
        this.loading = true;
        this.cd.detectChanges();
        // setTimeout(() => (this.loading = false), 3000); // small delay for effect
      } else {
        this.loading = false;
        this.cd.detectChanges();
      }
    });
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.domHandlerService.winScroll(0, 0);
      }
    });
  }
}
